import axios from "axios";
import { database_app } from "../../../component/var";

export async function AddNewsR6G(data) {
  try {
    const response = await axios.post(
      `${database_app}/api/r6g/cora/app/news`,
      data
    );
  } catch (error) {
    return { error: "Can't find news" };
  }
}
export async function AddMomentumsR6G(data) {
  try {
    const response = await axios.post(
      `${database_app}/api/r6g/cora/app/momentum`,
      data
    );
  } catch (error) {
    return { error: "Can't find news" };
  }
}

export async function UploadImageR6G(data) {
  try {
    const response = await axios.post(`${database_app}/api/upload`, data);
  } catch (error) {
    return { error: "Can't find news" };
  }
}
export async function UploadImageMomentumsR6G(data) {
  try {
    const response = await axios.post(
      `${database_app}/api/upload/momentum`,
      data
    );
  } catch (error) {
    return { error: "Can't find news" };
  }
}

export const getNewsR6G = async () => {
  try {
    const response = await axios.get(
      `${database_app}/api/r6g/cora/app/news/data`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Une erreur s'est produite lors de la récupération des éléments:",
      error
    );
    throw error;
  }
};

export const getMomentumsR6G = async () => {
  try {
    const response = await axios.get(
      `${database_app}/api/r6g/cora/app/momentum/data`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Une erreur s'est produite lors de la récupération des éléments:",
      error
    );
    throw error;
  }
};

export async function DeleteNewsR6G(id) {
  console.log();
  try {
    const response = await axios.delete(
      `${database_app}/api/r6g/cora/app/news/data/${id}`
    );
  } catch (error) {
    return { error: "Can't find news" };
  }
}
export async function DeleteMomentumsR6G(id) {
  try {
    const response = await axios.delete(
      `${database_app}/api/r6g/cora/app/momentum/data/${id}`
    );
  } catch (error) {
    return { error: "Can't find news" };
  }
}
